<form [formGroup]="formGroup" class="scheduleRequestForm">
    <lsq-checkbox
        label="Allow Schedule Request"
        [id]="'allow-schedule-request'"
        [formControlName]="'scheduleRequest'"
        [group]="formGroup"
        (change)="toggle()"
    >
    </lsq-checkbox>
    <div *ngIf="show">
        <span>Start Date</span>
        <lsq-input
            type="date"
            name="startDate"
            [formControlName]="'startDate'"
            [name]="'startDate'"
            [group]="formGroup"
        >
        </lsq-input>
        <div class="repeatContainer">
            <span style="margin-right: 2em;" class="label">Repeat Every:</span>
            <lsq-input
                class="repeatEvery"
                name="'repeatEvery'"
                formControlName="repeatEvery"
                [group]="formGroup"
                [digitsOnly]="true"
                style="margin-right: 2em;"
            >
            </lsq-input>
            <lsq-select
                class="repeats"
                id="repeat-select"
                [options]="['Day', 'Week', 'Month', 'Year']"
                [formControlName]="'repeats'"
                [name]="'repeats'"
                [group]="formGroup"
            >
            </lsq-select>
        </div>
    </div>
</form>
